/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PriceChangeReasonDTO { 
    reasonCode?: string;
    reason?: string;
    usageDesc?: string;
    fluidOrAdjustment?: string;
    order?: number;
}

